
import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Accepts a single employeeData object with all payroll fields
export function generateSampleSalarySlip(employeeData) {
  const doc = new jsPDF('p', 'pt', 'a4');

  // Company Name (bold, centered)
  doc.setFontSize(16);
  doc.setFont('helvetica', 'bold');
  doc.text('ALERT INTELLIGENCE SERVICES LTD', doc.internal.pageSize.getWidth() / 2, 50, { align: 'center' });

  // Address (centered)
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.text('4, Anand Lok Colony, Chinhat, Lucknow, Uttar Pradesh - 226028', doc.internal.pageSize.getWidth() / 2, 70, { align: 'center' });

  // Email (centered, underlined)
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.textWithLink('E-Mail : hr.alert@alertintell.com', doc.internal.pageSize.getWidth() / 2, 90, { align: 'center', url: 'mailto:hr.alert@alertintell.com' });

  // Pay Slip Title (bold, centered, with spacing)
  doc.setFontSize(15);
  doc.setFont('helvetica', 'bold');
  doc.text('Pay Slip', doc.internal.pageSize.getWidth() / 2, 120, { align: 'center' });

  // Payroll Month & Year (centered, from data)
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  const payrollMonth = employeeData['Month'] || '';
  doc.text(payrollMonth, doc.internal.pageSize.getWidth() / 2, 145, { align: 'center' });

  // Employee Name (centered)
  doc.setFontSize(12);
  doc.setFont('helvetica', 'normal');
  const employeeName = employeeData['Name'] || '';
  doc.text(employeeName, doc.internal.pageSize.getWidth() / 2, 170, { align: 'center' });

  // Single horizontal line below employee name
  doc.setLineWidth(0.7);
  const margin = 60;
  doc.line(margin, 185, doc.internal.pageSize.getWidth() - margin, 185);

  // --- Employee Details (two columns, mapped to fields) ---
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  const leftColX = margin;
  const rightColX = doc.internal.pageSize.getWidth() / 2 + 10;
  let detailsY = 205;

  // Left column
  doc.text('Employee Number:', leftColX, detailsY);
  doc.text(employeeData['Emp Code'] || '', leftColX + 110, detailsY);
  doc.text('Department:', leftColX, detailsY + 15);
  doc.text(employeeData['Department'] || '', leftColX + 110, detailsY + 15);
  doc.text('Sub Department:', leftColX, detailsY + 30);
  doc.text(employeeData['Sub Department'] || '', leftColX + 110, detailsY + 30);
  doc.text('Designation:', leftColX, detailsY + 45);
  doc.text(employeeData['Designation'] || '', leftColX + 110, detailsY + 45);
  doc.text('Branch:', leftColX, detailsY + 60);
  doc.text(employeeData['Branch'] || '', leftColX + 110, detailsY + 60);
  doc.text('Bank A/C No:', leftColX, detailsY + 75);
  doc.text(employeeData['Bank A/C No'] || '', leftColX + 110, detailsY + 75);
  doc.text('IFSC:', leftColX, detailsY + 90);
  doc.text(employeeData['IFSC'] || '', leftColX + 110, detailsY + 90);
  doc.text('Date of joining:', leftColX, detailsY + 105);
  doc.text(employeeData['Calendar Days'] || '', leftColX + 110, detailsY + 105);

  // Right column
  doc.text('PAN:', rightColX, detailsY);
  doc.text(employeeData['PAN'] || '', rightColX + 80, detailsY);
  doc.text('UAN:', rightColX, detailsY + 15);
  doc.text(employeeData['UAN'] || '', rightColX + 80, detailsY + 15);
  doc.text('ESIC No:', rightColX, detailsY + 30);
  doc.text(employeeData['ESIC No'] || '', rightColX + 80, detailsY + 30);
  doc.text('PF account number:', rightColX, detailsY + 45);
  doc.text(employeeData['PF'] || '', rightColX + 80, detailsY + 45);
  doc.text('TDS:', rightColX, detailsY + 60);
  doc.text(employeeData['TDS'] || '', rightColX + 80, detailsY + 60);
  doc.text('Loan:', rightColX, detailsY + 75);
  doc.text(employeeData['Loan'] || '', rightColX + 80, detailsY + 75);
  doc.text('Advance:', rightColX, detailsY + 90);
  doc.text(employeeData['Advance'] || '', rightColX + 80, detailsY + 90);
  doc.text('Net Payable:', rightColX, detailsY + 105);
  doc.text(employeeData['Net Payable'] || '', rightColX + 80, detailsY + 105);


  // --- Professional Tables using autoTable ---
  let sectionY = detailsY + 95;
  // Attendance Table
  doc.autoTable({
    startY: sectionY,
    head: [['Attendance Details', 'Value']],
    body: [['Payable Days', '']],
    theme: 'grid',
    headStyles: { fillColor: [255,255,255], textColor: 0, fontStyle: 'bold', halign: 'center', valign: 'middle', lineWidth: 0.5 },
    bodyStyles: { halign: 'left', valign: 'middle', lineWidth: 0.5 },
    styles: { font: 'helvetica', fontSize: 11, cellPadding: 2 },
    tableLineWidth: 0.5,
    margin: { left: margin, right: margin },
    columnStyles: { 0: { cellWidth: 120 }, 1: { cellWidth: 40, halign: 'center' } }
  });

  // Earnings & Deductions Table (side by side)
  const earningsRows = [
    ['Basic + Dearness Allowances', ''],
    ['Bonus', ''],
    ['HRA', ''],
    ['Medical Allowances', ''],
    ['Other Allowances', ''],
    ['Conveyance Allowances', ''],
    ['Special Allowances', ''],
    ['Performance Linked Incentive', ''],
    ['Arrear Amount', ''],
    ['Laptop Allowances', ''],
    [{ content: 'Total Earnings', styles: { fontStyle: 'bold' } }, ''],
    [{ content: 'Total', styles: { fontStyle: 'bold' } }, '']
  ];
  const deductionsRows = [
    ['Alert Foundation Fund', ''],
    ['Employee ESIC @ .75%', ''],
    ['Employee PF@12%', ''],
    ['Advance Salary / Loan Deduction', ''],
    [{ content: 'Total Deductions', styles: { fontStyle: 'bold' } }, ''],
    [{ content: 'Net Amount', styles: { fontStyle: 'bold' } }, '']
  ];
  const earningsTableX = margin;
  const deductionsTableX = doc.internal.pageSize.getWidth() / 2;
  const earningsTableY = doc.lastAutoTable.finalY + 5;
  doc.autoTable({
    startY: earningsTableY,
    head: [['Earnings', 'Amount']],
    body: earningsRows,
    theme: 'grid',
    headStyles: { fillColor: [255,255,255], textColor: 0, fontStyle: 'bold', halign: 'center', valign: 'middle', lineWidth: 0.5 },
    bodyStyles: { halign: 'left', valign: 'middle', lineWidth: 0.5 },
    styles: { font: 'helvetica', fontSize: 11, cellPadding: 2 },
    tableLineWidth: 0.5,
    margin: { left: earningsTableX },
    tableWidth: doc.internal.pageSize.getWidth() / 2 - margin
  });
  doc.autoTable({
    startY: earningsTableY,
    head: [['Deductions', 'Amount']],
    body: deductionsRows,
    theme: 'grid',
    headStyles: { fillColor: [255,255,255], textColor: 0, fontStyle: 'bold', halign: 'center', valign: 'middle', lineWidth: 0.5 },
    bodyStyles: { halign: 'left', valign: 'middle', lineWidth: 0.5 },
    styles: { font: 'helvetica', fontSize: 11, cellPadding: 2 },
    tableLineWidth: 0.5,
    margin: { left: deductionsTableX },
    tableWidth: doc.internal.pageSize.getWidth() / 2 - margin
  });

  // Employer Contribution Table
  const empContribRows = [
    ['Employer EPS@8.33%', ''],
    ['Employer ESIC @ 3.25%', ''],
    ['Employer Provident Fund @ 3.67%', ''],
    [{ content: 'Total', styles: { fontStyle: 'bold' } }, '']
  ];
  const empContribY = Math.max(doc.lastAutoTable.finalY + 5, earningsTableY + 11 * 11 + 30);
  doc.autoTable({
    startY: empContribY,
    head: [['Employer Contribution', 'Amount']],
    body: empContribRows,
    theme: 'grid',
    headStyles: { fillColor: [255,255,255], textColor: 0, fontStyle: 'bold', halign: 'center', valign: 'middle', lineWidth: 0.5 },
    bodyStyles: { halign: 'left', valign: 'middle', lineWidth: 0.5 },
    styles: { font: 'helvetica', fontSize: 11, cellPadding: 2 },
    tableLineWidth: 0.5,
    margin: { left: margin },
    tableWidth: 300
  });

  // --- Amount (in words) ---
  let amtWordsY = doc.lastAutoTable.finalY + 10;
  doc.setFont('helvetica', 'normal');
  doc.text('Amount (in words):', margin, amtWordsY);

  // --- Signature Area ---
  let signY = amtWordsY + 40;
  doc.setFont('helvetica', 'normal');
  doc.text('for ALERT INTELLIGENCE SERVICES LTD', doc.internal.pageSize.getWidth() - margin, signY, { align: 'right' });
  doc.text('Authorised Signatory', doc.internal.pageSize.getWidth() - margin, signY + 30, { align: 'right' });

  // ...existing code...

  doc.save('Sample_Salary_Slip.pdf');
}
